var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('rect',{attrs:{"x":_vm.x + 4,"y":_vm.y,"height":_vm.h,"width":_vm.w - 8,"fill":"white","rx":4,"ry":4}}),_c('text',{attrs:{"x":_vm.x + 4,"y":_vm.y,"dx":(_vm.w - 8) / 2,"dy":_vm.h / 2}},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }